<template>
  <div :class="topPage ? 'content-container' : ''">
    <el-breadcrumb separator="/" v-if="topPage">
      <el-breadcrumb-item :to="{ path: '/dashboard' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>客户设备</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- <h6 class="content-header">客户</h6> -->
    <div class="panel mt-20">
      <div class="filter">
        <el-form :model="filter" ref="filterForm" label-position="left" label-width="70px" @submit.native.prevent>
          <el-form-item label="关键字" prop="query" v-if="isMobile() && !filterShow">
            <el-input size="small" v-model="filter.query" autocomplete="off" placeholder="机型、序列号、设备号" @keyup.enter.native="reqeustCustomerDevices"></el-input>
          </el-form-item>
          <div class="filter-block" v-show="filterShow || !isMobile()">
            <el-form-item label="关键字" prop="query" v-if="filterShow || !isMobile()">
              <el-input size="small" v-model="filter.query" autocomplete="off" placeholder="机型、序列号、设备号" @keyup.enter.native="reqeustCustomerDevices"></el-input>
            </el-form-item>
            <!-- <el-form-item label="最终客户" prop="install_customer_id">
              <customer-select
                :val="filter.install_customer_id"
                @change="filter.install_customer_id = $event"
              ></customer-select>
            </el-form-item> -->
            <!-- <el-form-item
              label="中间商"
              prop="sold_customer_id"
              v-if="auth.isPlatformUser()"
            >
              <customer-select
                :val="filter.sold_customer_id"
                @change="filter.sold_customer_id = $event"
              ></customer-select>
            </el-form-item>
            <el-form-item
              label="OEM厂商"
              prop="oem_customer_id"
              v-if="auth.isPlatformUser()"
            >
              <customer-select
                :val="filter.oem_customer_id"
                @change="filter.oem_customer_id = $event"
              ></customer-select>
            </el-form-item> -->
            <!-- <el-form-item
              label="客户类型"
              v-if="customerID == 0 && auth.isPlatformUser()"
            >
              <el-select
                v-model="filter.customer_category"
                size="small"
                placeholder="请选择"
                style="width: 100%"
                :clearable="true"
              >
                <el-option
                  v-for="(value, index) in CustomerCategroyMap"
                  :key="index"
                  :label="value"
                  :value="parseInt(index)"
                ></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="分类" prop="item_category_id">
              <item-category-select :val="filter.item_category_id" :category="2" @change="filter.item_category_id = $event"></item-category-select>
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model="filter.status" size="small" placeholder="请选择" style="width: 100%">
                <el-option v-for="(value, index) in CustomerDeviceStatusMap" :key="index" :label="value" :value="parseInt(index)"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="SAP维护" v-if="auth.isPlatformUser()">
              <el-select v-model="filter.sap_sync" size="small" placeholder="请选择" style="width: 100%">
                <el-option :key="-1" label="所有" :value="-1"></el-option>
                <el-option :key="0" label="未维护" :value="0"></el-option>
                <el-option :key="1" label="已维护" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="最终客户" v-if="auth.isPlatformUser()">
              <el-select v-model="filter.install_customer_blank" size="small" placeholder="请选择" style="width: 100%">
                <el-option :key="0" label="所有" :value="0"></el-option>
                <el-option :key="1" label="有" :value="1"></el-option>
                <el-option :key="2" label="无" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="特征">
              <el-checkbox v-model="filter.name_plate_no_sn">有铭牌无SN号</el-checkbox>
            </el-form-item>
            <!-- <el-form-item label="发货日期" prop="date">
              <el-date-picker
                style="width: 360px"
                v-model="filter.date"
                type="daterange"
                size="small"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item> -->
          </div>
        </el-form>
        <div class="mt-10 flex-row-between">
          <div>
            <el-button
              type="primary"
              size="small"
              @click="
                filter.page = 1
                reqeustCustomerDevices()
              "
              >筛选</el-button
            >
            <el-button size="small" @click="reset()">重置</el-button>
          </div>
          <div
            class="flex-row-base"
            v-if="isMobile()"
            @click="
              filterShow = !filterShow
              scrollToTop()
            "
          >
            <i class="text-gray" :class="filterShow ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></i>
            <span class="text-info-12">
              {{ filterShow ? '隐藏高级筛选' : '展开高级筛选' }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="panel mt-20">
      <el-table v-if="!isMobile()" v-loading="loading" ref="customerDeviceTable" :data="devices" stripe style="width: 100%" size="mini" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" v-if="customerID > 0 && hasAuth('customerDeviceDelete')"> </el-table-column>
        <el-table-column prop="customer.name" :label="`序列号${auth.isPlatformUser() ? '/设备号/最终客户/中间商' : '/客户'}`" min-width="220">
          <template slot-scope="scope">
            <div class="flex-row">
              <span v-if="auth.isPlatformUser()"> 序列号：{{ scope.row.serial_number.length > 0 ? scope.row.serial_number : '-' }} </span>
              <span v-else :class="{ 'text-info-12': scope.row.serial_number.length == 0 }">
                {{ scope.row.serial_number.length > 0 ? scope.row.serial_number : '未设置序列号' }}
              </span>
              <viewer v-if="scope.row.name_plate && scope.row.name_plate.length > 0" class="viewer" ref="viewer">
                <auth-img tag="el-image" style="width: 16px; height: 16px; margin-left: 5px" :src="scope.row.name_plate" :preview-src-list="[scope.row.name_plate]" />
              </viewer>
            </div>
            <div v-if="auth.isPlatformUser()">设备号：{{ scope.row.equipment_number.length > 0 ? scope.row.equipment_number : '-' }}</div>
            <div v-if="auth.isPlatformUser() && customerID > 0">
              <div v-if="scope.row.address.whole_name">设备地址：{{ scope.row.address.whole_name }}</div>
              <!-- <div v-if="scope.row.dealer_id">
                <customer-link
                  class="font-12"
                  :customer="scope.row.dealer"
                ></customer-link>
              </div> -->
            </div>
            <template>
              最终客户：
              <span class="mr-5">{{ scope.row.customer.name }}</span>
              <template v-if="auth.isPlatformUser()">
                <!-- <span class="cc" v-if="scope.row.customer.category == 1"
                  >最终客户</span
                > -->
                <!-- <span class="cc" v-else-if="scope.row.customer.dealer_id">
                  {{ DealerCategories[scope.row.customer.dealer.category_id] }}
                </span> -->
                <!-- <div v-if="scope.row.sold_customer_id">
                  中间商：
                  <customer-link
                    class="font-12"
                    :customer="scope.row.dealer"
                  ></customer-link>
                  <span class="cc ml-5">
                    {{ DealerCategories[scope.row.dealer.category] }}
                  </span>
                </div> -->
              </template>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="分类/机型/备注" min-width="200" align="left">
          <template slot-scope="scope">
            <div class="font-12">{{ scope.row.item_category.whole_name }}</div>
            <div class="text-info-12">机型：{{ scope.row.machine_type }}</div>
            <div class="text-info-12">描述：{{ scope.row.description || '-' }}</div>
            <div class="text-info-12">备注：{{ scope.row.desc || '-' }}</div>
            <!-- <el-tooltip
              placement="top"
              v-if="auth.isPlatformUser() && scope.row.oem_customer_id > 0"
            >
              <div slot="content">{{ scope.row.firm.name }}</div>
              <span class="text-info-12">OEM制造</span>
            </el-tooltip> -->
          </template>
        </el-table-column>
        <el-table-column prop="purchase_time" label="发货日期" width="125" align="center">
          <template slot-scope="scope">
            <span>{{ formatTime(scope.row.purchase_time) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="oil_type" label="泵油类型" width="125" align="center"> </el-table-column>
        <el-table-column prop="working_condition" label="工况/运行时长" width="130" align="center">
          <template slot-scope="scope">
            <span class="font-12">{{ scope.row.working_condition }}</span>
            <br />
            <span class="font-12">{{ scope.row.running_time }}</span>
            <br />
            <span class="font-12" v-if="scope.row.running_time_updated_at">({{ scope.row.running_time_updated_at }}更新)</span>
          </template>
        </el-table-column>
        <el-table-column prop="product_name" label="公司产品" width="100" align="center" v-if="auth.isPlatformUser()"></el-table-column>
        <el-table-column prop="product_application" label="应用工艺" width="100" align="center" v-if="auth.isPlatformUser()">
          <template slot-scope="scope"> <div v-html="scope.row.product_application ? scope.row.product_application.join(' <br/> ') : ''"></div></template>
        </el-table-column>
        <!-- <el-table-column
          prop="service_count"
          label="服务请求数量"
          width="120"
          align="center"
          v-if="auth.isPlatformUser()"
        >
          <template slot-scope="scope">
            <router-link
              v-if="customerID == 0 && scope.row.customer_id"
              :to="`/dashboard/final_customers/${scope.row.customer_id}?tab=tab11&device_id=${scope.row.id}`"
            >
              {{ scope.row.service_count }}
            </router-link>
            <div v-else>{{ scope.row.service_count }}</div>
          </template>
        </el-table-column> -->
        <el-table-column label="状态" width="80" align="center">
          <template slot-scope="scope">
            <status-tag class="font-12" :type="deviceStatusType(scope.row.status)" :name="CustomerDeviceStatusMap[scope.row.status]"></status-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="110" fixed="right">
          <template slot-scope="scope">
            <!-- <el-popconfirm
              title="确定删除吗？"
              v-if="customerID > 0"
              @confirm="handleDeleteCustomerDevice(scope.row, scope.$index)"
              v-permission="Auth.customerDeviceDelete"
            >
              <el-button
                slot="reference"
                type="text"
                class="text-danger"
                size="mini"
                style="width: 100%"
                >删除</el-button
              >
            </el-popconfirm> -->
            <el-button type="text" size="mini" @click="startCustomerDeviceFormer(scope.row, scope.$index)" v-permission="Auth.customerDeviceEdit">编辑信息</el-button>
            <!-- <el-button
              type="text"
              size="mini"
              class="ml-0"
              @click="startServiceQuestFormer(scope.row)"
              v-permission="Auth.serviceQuestCreate"
              >添加服务请求</el-button
            >
            <template v-if="auth.isPlatformUser()">
              <el-popconfirm
                title="确实变更SAP同步状态？"
                v-if="!scope.row.sap_sync"
                @confirm="swithSapSyncStatus(scope.row, scope.$index)"
                v-permission="Auth.customerDeviceSAP"
              >
                <el-button slot="reference" type="text" size="mini"
                  >维护到SAP</el-button
                >
              </el-popconfirm>
              <div v-else class="text-info-12">
                <i class="el-icon-check"></i>
                已维护到SAP
              </div>
            </template> -->
          </template>
        </el-table-column>
      </el-table>
      <ul v-else class="list-style">
        <li v-for="(item, index) in devices" :key="item.id" style="align-items: start">
          <div>
            <div class="flex-row-between" style="height: 20px; line-height: 20px; margin-bottom: 10px">
              <div class="flex-row" style="line-height: 1.5; align-items: center">
                <span> 序列号：{{ item.serial_number.length > 0 ? item.serial_number : '-' }} </span>
                <viewer v-if="item.name_plate && item.name_plate.length > 0" style="line-height: 1" class="viewer" ref="viewer">
                  <img style="width: 16px; height: 16px; margin-left: 5px" :src="item.name_plate.includes('http') ? item.name_plate : thumbnailImagePath + item.name_plate" :data-src="item.name_plate.includes('http') ? item.name_plate : originImagePath + item.name_plate" />
                </viewer>
              </div>
              <el-button type="primary" class="text-primary" size="mini" plain @click="startCustomerDeviceFormer(item, index)" v-permission="Auth.customerDeviceEdit">编辑</el-button>
            </div>
            <div class="font-12" v-if="auth.isPlatformUser()">
              <span>设备号：</span>
              {{ item.equipment_number.length > 0 ? item.equipment_number : '' }}
            </div>
            <div class="font-12">
              <span>分类：</span>
              <span>{{ item.item_category.whole_name }}</span>
              <el-tooltip placement="top" v-if="item.firm_id > 0">
                <div slot="content">OEM厂商：{{ item.firm.name }}</div>
                <i class="el-icon-warning-outline"></i>
              </el-tooltip>
            </div>
            <div class="font-12">
              <span>机型：</span>
              <span v-if="item.machine_type.length > 0">
                {{ item.machine_type }}
              </span>
              <span v-else>-</span>
            </div>
            <div class="font-12">
              <span>备注：</span>
              <span v-if="item.desc.length > 0">
                {{ item.desc }}
              </span>
              <span v-else>-</span>
            </div>
            <div class="font-12">
              <span>完保日期：</span>
              {{ item.last_maintenance_date }}
            </div>
            <div class="text-info-12 flex-row-between" v-if="item.working_condition.length > 0 || item.running_time > 0">
              <span>开机：{{ formatTime(item.purchase_time) }}</span>
              <span>工况：{{ item.working_condition }}</span>
              <span>时长：{{ item.running_time }}</span>
            </div>
            <div class="text-info-12" v-if="customerID == 0">
              客户：
              <customer-link :customer="item.customer"></customer-link>
            </div>
          </div>
        </li>
      </ul>
      <div v-if="devices.length == 0 && isMobile()" class="text-info-12">
        无设备数据。
      </div>
      <div class="table-option">
        <!-- <div
          class="ml-10"
          v-if="customerID > 0"
          v-permission="Auth.customerDeviceDelete"
        >
          <el-checkbox v-model="selectedAll" @change="handleSelectedAllChange"
            >全选</el-checkbox
          >
          <el-button
            type="danger"
            size="small"
            class="ml-5"
            @click="batchDeleteCustomerDevice"
            v-permission="Auth.customerDeviceDelete"
            >批量删除</el-button
          >
          <el-button
            type="info"
            size="small"
            class="ml-5"
            @click="batchTransferCustomerDevice"
            v-permission="Auth.customerDeviceEdit"
            >批量转移</el-button
          >
        </div> -->

        <el-pagination :page-size="filter.size" :current-page.sync="filter.page" layout="total, prev, pager, next" :total="total"></el-pagination>
      </div>
    </div>

    <CustomerTransfer :show.sync="transferFormVisible" :model="transferModel" :filterCustomerID="fixedCustomer ? fixedCustomer.id : 0" @updated="reset"></CustomerTransfer>

    <customer-device-former :model="customerDeviceForm" :customerName="selectDeviceCustomerName" :fixedCustomer="fixedCustomer" :show.sync="createCustomerDeviceFormVisible" :showAddress="true" @updated="updatedCustomerDevcice" @created="createdCustomerDevcice"></customer-device-former>

    <service-quest-former :model="serviceQuestForm" :show.sync="addServiceQuestFormVisible" @created="createdServiceQuest"></service-quest-former>
  </div>
</template>

<script>
import { customerDeviceList, itemCategoryList, customerDeviceDelete, updateCustomerDeviceSapsync } from '../../service/getData'
import auth from '@/util/auth'
import { isMobile, formatTime, scrollToTop } from '@/util/index'
import CustomerDeviceFormer from '@/components/customer_device'
import CustomerSelect from '@/components/select/customer_select'
import ItemCategorySelect from '@/components/select/item_category_select'
import { clone } from '@/util'
import { host, thumbnailImagePath, originImagePath } from '@/config/env'
import { CustomerDeviceStatusMap, CustomerCategroyMap, DealerCategories } from '@/config/global.js'
import Customer_link from '../../components/customer_link/customer_link.vue'
import { hasAuth } from '@/permission'
import { CodeToText } from '@/util/area_tool'

import CustomerTransfer from './customer_transfer_former'
import DealerSelect from '@/components/select/dealer_select'
import ServiceQuestFormer from '../../components/service_quest'

export default {
  components: {
    CustomerDeviceFormer,
    CustomerSelect,
    ItemCategorySelect,
    CustomerTransfer,
    DealerSelect,
    ServiceQuestFormer,
  },
  props: {
    customerID: {
      type: Number,
      default: 0,
    },
    fixedCustomer: {
      type: Object,
    },
    customerDeleted: {
      type: Number,
      default: 0,
    },
    // dealerID: {
    //   type: Number,
    //   default: 0,
    // },
    topPage: {
      type: Boolean,
      default: true,
    },
    // isOwner: {
    //   type: Boolean,
    //   default: false,
    // },
  },
  data() {
    return {
      hasAuth,
      filter: {
        query: '',
        customer_id: this.customerID || 0,
        sold_customer_id: 0,
        oem_customer_id: 0,
        install_customer_id: 0,
        item_category_id: 0,
        status: null,
        size: 20,
        page: 1,
        features: [],
        sap_sync: -1,
        install_customer_blank: 0,
        name_plate_no_sn: false,
        // firm_id: 0,
        // dealer_id: 0,
        customer_category: 0,
      },
      serviceQuestForm: {},
      addServiceQuestFormVisible: false,
      selectDeviceCustomerName: null,
      DealerCategories,
      CustomerCategroyMap,
      CustomerDeviceStatusMap,
      isMobile,
      scrollToTop,
      host,
      thumbnailImagePath,
      originImagePath,
      formatTime,
      total: 0,
      sales: [],
      auth,
      devices: [],
      filterShow: false,
      loading: false,
      customerDeviceForm: { address: { detail: '' } },
      editDeviceIndex: 0,
      createCustomerDeviceFormVisible: false,
      transferFormVisible: false,
      transferModel: {
        sold_customer_id: 0,
        oem_customer_id: 0,
        install_customer_id: 0,
        ids: [],
      },
      selectedAll: false,
      selectedIDs: [],
    }
  },
  computed: {},
  watch: {
    'filter.page': function() {
      this.reqeustCustomerDevices()
    },
    // customerID: function () {
    //   this.filter.customer_id = this.customerID
    // },
  },
  created() {
    let status = parseInt(this.$route.query.status || -1)
    status = status < 0 ? null : status

    let cc = parseInt(this.$route.query.customer_category || 0)
    if (cc == 0) {
      cc = null
    }

    this.filter = {
      page: parseInt(this.$route.query.page || 1),
      size: parseInt(this.$route.query.size || 20),
      customer_id: parseInt(this.$route.query.customer_id || 0),
      sold_customer_id: parseInt(this.$route.query.sold_customer_id || 0),
      oem_customer_id: parseInt(this.$route.query.oem_customer_id || 0),
      install_customer_id: parseInt(this.$route.query.install_customer_id || 0),
      item_category_id: parseInt(this.$route.query.item_category_id || 0),
      query: this.$route.query.query || '',
      customer_category: cc,
      status: status,
      sap_sync: parseInt(this.$route.sap_sync || -1),
      install_customer_blank: parseInt(this.$route.install_customer_blank || 0),
      name_plate_no_sn: this.$route.query.name_plate_no_sn === 'true',
      date: this.$route.query.date || [],
    }

    if (this.customerID) {
      this.filter.customer_id = this.customerID
    }

    this.filter.all = this.customerID == 0
    this.reqeustCustomerDevices()
  },
  methods: {
    async reqeustCustomerDevices() {
      let data = {
        size: this.filter.size,
        page: this.filter.page - 1,
        query: this.filter.query,
        sap_sync: this.filter.sap_sync,
        install_customer_blank: this.filter.install_customer_blank,
        sold_customer_id: this.filter.sold_customer_id || 0,
        oem_customer_id: this.filter.oem_customer_id || 0,
        install_customer_id: this.filter.install_customer_id || 0,
        customer_id: this.customerID || 0,
        item_category_id: this.filter.item_category_id,
        status: this.filter.status == null ? -1 : this.filter.status,
        features: this.filter.features || [],
        customer_category: this.filter.customer_category || 0,
        name_plate_no_sn: this.filter.name_plate_no_sn || false,
        pending_device: true,
      }

      this.$router.replace({
        query: this.filter,
      })

      this.loading = true

      if (this.filter.date && this.filter.date.length == 2) {
        data.start_time = this.filter.date[0] || ''
        data.end_time = this.filter.date[1] || ''
      }

      let res = await customerDeviceList(data)
      if (res.code == 0) {
        this.devices = res.data.list.map((item) => {
          if (item.item_category) {
            item.item_category.whole_name = item.item_category.whole_name.replace(/,/g, ' - ')
          }

          if (!item.customer_device_address_id) {
            item.address.whole_name = CodeToText[item.customer.province] + CodeToText[item.customer.city] + CodeToText[item.customer.county] + item.customer.address_detail
          }
          return item
        })
        this.total = res.data.total
      }
      this.selectedAll = false
      this.loading = false
    },
    reset() {
      this.filter.query = ''
      this.filter.customer_id = this.customerID || 0
      this.filter.item_category_id = 0
      this.filter.page = 1
      this.filter.status = null
      this.filter.name_plate_no_sn = false
      this.filter.sap_sync = -1
      this.filter.install_customer_blank = 0
      this.filter.oem_customer_id = 0
      this.filter.sold_customer_id = 0
      this.filter.install_customer_id = 0
      this.filter.customer_category = null
      this.filter.date = []
      this.reqeustCustomerDevices()
    },
    importCallback(res) {
      if (res.code == 0) {
        this.reset()
      }
    },
    startCustomerDeviceFormer(device, index) {
      if (device) {
        this.customerDeviceForm = clone(device)
        this.selectDeviceCustomerName = device.customer.name
        this.editDeviceIndex = index
      } else {
        this.customerDeviceForm = {
          // dealer_id: null,
          install_customer_id: this.customerID,
          working_condition: '',
          running_time: null,
          purchase_time: null,
          name_plate: null,
          serial_number: null,
          machine_type: null,
          oil_type: null,
          desc: '',
          description: null,
          item_category_id: null,
          equipment_number: null,
          product_name: null,
          product_application: [],
          status: 0,
          address: { detail: '', province: '', city: '', county: '' },
        }
      }
      this.createCustomerDeviceFormVisible = true
    },
    createdCustomerDevcice(customerDevice) {
      if (customerDevice.item_category) {
        customerDevice.item_category.whole_name = customerDevice.item_category.whole_name.replace(/,/g, ' - ')
      }
      this.devices.unshift(customerDevice)
    },
    updatedCustomerDevcice(customerDevice) {
      if (customerDevice.item_category) {
        customerDevice.item_category.whole_name = customerDevice.item_category.whole_name.replace(/,/g, ' - ')
      }
      if (this.customerID > 0 && customerDevice.customer_id != this.customerID) {
        this.devices.splice(this.editDeviceIndex, 1)
      } else {
        this.devices.splice(this.editDeviceIndex, 1, customerDevice)
      }
    },
    selectTable(row, index) {
      return row.serial_number == ''
    },
    handleSelectedAllChange(val) {
      if (val) {
        this.$refs.customerDeviceTable.toggleAllSelection()
      } else {
        this.$refs.customerDeviceTable.clearSelection()
      }
    },
    handleSelectionChange(items) {
      this.selectedAll = items.length == this.devices.length && this.devices.length > 0

      this.selectedIDs = items.map((item) => {
        return item.id
      })
    },
    async handleDeleteCustomerDevice(device, index) {
      let res = await customerDeviceDelete({ ids: [device.id] })
      if (res.code == 0) {
        this.devices.splice(index, 1)

        this.selectedAll = this.selectedIDs.length == this.devices.length && this.devices.length > 0
      }
    },
    async batchDeleteCustomerDevice() {
      if (this.selectedIDs.length == 0) {
        this.$alert('请至少选择一件设备')
        return
      }

      this.$confirm('确认删除选中设备嘛?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          let res = await customerDeviceDelete({ ids: this.selectedIDs })
          if (res.code == 0) {
            this.reqeustCustomerDevices()
          }
        })
        .catch(() => {})
    },

    batchTransferCustomerDevice() {
      if (this.selectedIDs.length == 0) {
        this.$alert('请至少选择一件设备')
        return
      } else {
        this.transferModel.ids = this.selectedIDs
        this.transferModel.sold_customer_id = ''
        this.transferModel.oem_customer_id = ''
        this.transferModel.install_customer_id = ''
        this.transferFormVisible = true
      }
    },
    async swithSapSyncStatus(device, index) {
      let data = {
        sap_sync: 1 - device.sap_sync,
        id: device.id,
      }
      let res = await updateCustomerDeviceSapsync(data)
      if (res.code == 0) {
        device.sap_sync = res.data.sap_sync
        this.$message.success('操作成功')
      }
    },
    deviceStatusType(type) {
      switch (type) {
        case 0:
          return 'success'
        case 1:
          return 'info'
        case 2:
          return 'gray'
        case 3:
          return 'gray'
        case 4:
          return 'info'
        case 5:
          return 'danger'
        case 6:
          return 'info'
      }
    },
    startServiceQuestFormer(device) {
      this.serviceQuestForm = {
        customer_id: device.install_customer_id || '',
        dealer_id: device.dealer.twin_id || '',
        customer_contact_id: 0,
        quest_dealer_contact_id: 0,
        customer_device_id: device.id,
        desc: '',
        level: 1,
        flow_id: null,
        category: 1,
        sub_category: null,
        cmm_category: null,
        customer_device_address_id: device.customer_device_address_id || 0,
        dealer: { id: device.dealer.twin_id },
      }
      this.addServiceQuestFormVisible = true
    },

    createdServiceQuest(res) {
      if (res.id) {
        this.$router.push(`/dashboard/service_quests/new/${res.id}?origin=0`)
      }
    },
  },
}
</script>

<style scoped>
/deep/ .el-checkbox__label {
  font-size: 12px !important;
}

.cc {
  padding: 1px 3px;
  border: 1px solid #ddd;
  border-radius: 3px;
  font-size: 12px;
  word-break: keep-all;
  /* margin-left: 4px; */
}

.table-option {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  flex-wrap: wrap;
}
</style>
